import React from "react";
import { Modal } from "react-bootstrap";

const AdmissionModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Admission Procedure for 2025-2026</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          As an esteemed institution, we proudly uphold our affiliation with the
          Maharashtra State Board, adhering strictly to its norms and guidelines
          for admissions. We are committed to integrity and transparency in all
          aspects of the admission process and firmly denounce any form of
          admission through dubious means.
        </p>
        <p>
          At SMG English School, the admission process is governed by ethical
          standards, with the School Management serving as the sole
          decision-making authority in all matters related to admissions. Guided
          by principles of fairness and equity, we uphold the dignity and
          reputation of our institution at all times.
        </p>

        <h4>
          Important Instructions and Guidelines for Online Admission Procedure:
        </h4>
        <ol>
          <li>
            <strong>Online Registration</strong>
            <br />
            The Online Registration Form for Preschool (Nursery, Junior KG,
            Senior KG) admissions for the academic year 2025-2026 will be
            available on our website starting 1st January 2025.
          </li>
          <li>
            <strong>Eligibility Criteria</strong>
            <br />
            Children born in 2022 are eligible for admission to Nursery.
            <br />
            Children born in 2021 are eligible for admission to Junior KG.
            <br />
            Children born in 2020 are eligible for admission to Senior KG.
          </li>
          <li>
            <strong>Registration Process</strong>
            <br />
            Parents must complete the Online Registration Form and upload the
            required documents.
            <br />
            An interactive session for parents who have registered online will
            be conducted. Both parents are required to attend the session at the
            school on the date and time specified via text message/WhatsApp.
          </li>
          <li>
            <strong>Selection and Notifications</strong>
            <br />
            Shortlisted candidates will be notified via text message/WhatsApp.
            <br />
            Parents must complete the payment of prescribed fees through the
            link provided by the school.
          </li>
          <li>
            <strong>Document Submission</strong>
            <br />
            Parents are required to submit original, authenticated documents at
            the school office.
          </li>
          <li>
            <strong>Transportation Facility</strong>
            <br />
            Parents opting for the school transportation facility must fill out
            the Bus Transportation Form.
          </li>
        </ol>

        <p>
          <strong>Additional Notes:</strong>
        </p>
        <ul>
          <li>Acquiring a registration form does not guarantee admission.</li>
          <li>
            Seats are limited, and it may not be possible to accommodate all
            registered students.
          </li>
          <li>
            The Principal retains full discretion in all matters related to
            admissions.
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-pri"
          onClick={() =>
            (window.location.href =
              "https://erp.p1.decagonsoftware.com/apps/ap/?ID=smgschools")
          }
        >
          Proceed to Registration
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdmissionModal;
